import Directory from '../../components/directory/Directory.component';

const Home = () => {
  return <Directory />;
};

export default Home;
